// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  projectId: __t.string().primaryKey().name("project_id"),
  agentIdentity: __t.identity().name("agent_identity"),
  displayName: __t.string().name("display_name"),
  updatedAt: __t.timestamp().name("updated_at"),
  agentServiceName: __t.option(__t.string()).name("agent_service_name"),
});
